import router from "@/router";
import { isToufang } from "./base";
import { Toast } from 'vant'

export const calcScores = (scores) => {
    return +scores / 10
}

export function getParams() {
    const queryParams = {};
    const queryString = window.location.search.substring(1);
    const params = queryString.split('&');

    params.forEach(param => {
        const [key, value] = param.split('=');
        queryParams[key] = decodeURIComponent(value || '');
    });

    return queryParams;
}

export function getParam(key){
    return getParams()[key];
}

export const setStorage = (key, value) => {
    if(typeof value === "object" && value !== null){
        value = JSON.stringify(value)
    }
    localStorage.setItem(key, value);
}

export const getStorage = (key) => {
    return localStorage.getItem(key)
}

export const removeStorage = (key) => {
    localStorage.removeItem(key)
}

export const clearStorage = () => {
    localStorage.clear();
}

export const calcPrice = (price) => {
    return price / 100
}

export const isFacebookWebView = () => {
  const ua = window.navigator.userAgent;
  const referrer = document.referrer
  return /FB_IAB|FBAN|FBAV|FBWEBVIEW|FBANLITE|Facebook/i.test(ua) || referrer.includes('facebook');
};

export const isTiktokWebView = () => {
    // 方法1：检查用户代理(UA)标识
  const userAgent = navigator.userAgent.toLowerCase();
  const isTikTokUA = /(tiktok)|(musically)|(bytedance)/i.test(userAgent);
  
  // 方法2：检查TikTok特有的JS对象（更可靠）
  const isTikTokEnv = typeof webview !== 'undefined' && 
                     webview?.name === 'TikTok';
  
  // 方法3：检查TikTok特有的URL参数
  const urlParams = new URLSearchParams(window.location.search);
  const hasTikTokParam = urlParams.has('tt_webid') || 
                         urlParams.has('tt_chain_token');
  
  return isTikTokUA || isTikTokEnv || hasTikTokParam;
}

export const isToufangWebView = () => {
    return isFacebookWebView() || isTiktokWebView();
}


export const isAndroid = () => {
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return isAndroid;
}

export const isIos = () => {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isiOS;
}


// 随机数
export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const goToRouter = (path, query = {}) => {
    const obj = {}
    if(isToufangWebView() || getParam('ch')){
        obj.ch = '1'
    }
    const q = router.app.$route.query
    router.app.$router.push({
        path,
        query: {
            ...q,
            ...query,
            ...obj,
        }
    })
}

export const saveImage = async (imgUrl) => {
    return await fetch(imgUrl)
        .then(response => response.blob())
        .then(blob => {
            // 创建一个指向Blob的URL
            var blobUrl = URL.createObjectURL(blob);
            // 创建一个链接元素
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            // 获取文件名
            var fileName = imgUrl.split('/').pop();
            // 设置下载的文件名
            a.download = fileName; // 你可以根据实际情况设置文件名，也可以从原URL中提取
            // 将链接添加到文档中
            document.body.appendChild(a);
            // 触发点击链接
            a.click();
            // 清理：移除链接和释放Blob URL
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
            Toast('Photo saved!')
        }).catch(() => {
            Toast('Save Failed')
        })
}

// 深克隆
export const deepClone = (arg) => {
  let res = null
  // 判断如果是数组则创建数组
  if (arg instanceof Array) {
    res = []
    // 如果是对象，则创建对象
  } else if (typeof arg === 'object' && arg !== null) {
    res = {}
  }
  for (var attr in arg) {
    // 判断是否为引用类型（array，object） 则需要克隆存入到新的地址
    if (typeof arg[attr] === 'object' && arg[attr] !== null) {
      res[attr] = deepClone(arg[attr])
    } else {
      // 其他类型直接赋值
      res[attr] = arg[attr]
    }
  }
  return res
}


/**
 * 复制文案
 * @param {String} text 
 */
export const copy = (text) => {
  const textString = text.toString();

  // 优先使用现代Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(textString).then(() => {
      showNotification();
    }).catch(err => {
      // 如果新API失败，回退到原有方法
      fallbackCopy(textString);
    });
  } else {
    // 不支持Clipboard API，使用原有方法
    fallbackCopy(textString);
  }
};


const fallbackCopy = (textString) => {
  let input = document.querySelector('#copy-input');
  if (!input) {
    input = document.createElement('input');
    input.id = "copy-input";
    input.readOnly = "readOnly";
    // 使用更安全的隐藏方式
    input.style.position = "fixed";
    input.style.top = "0";
    input.style.left = "0";
    input.style.opacity = "0";
    input.style.pointerEvents = "none";
    document.body.appendChild(input);
  }

  input.value = textString;

  // 保存当前滚动位置
  const scrollY = window.scrollY || document.documentElement.scrollTop;

  // 选择文本
  selectText(input, 0, textString.length);

  try {
    const successful = document.execCommand('copy');
    if (successful) {
      console.log('复制成功')
      showNotification();
    } else {
      console.log('复制失败');
    }
  } catch (err) {
    console.log('复制命令不支持', err);
  }

  input.blur();

  // 恢复滚动位置
  window.scrollTo(0, scrollY);
};

// 选择文本
const selectText = (input, start, end) => {
  if (input.setSelectionRange) {
    input.focus({ preventScroll: true }); // 防止滚动
    input.setSelectionRange(start, end);
  } else if (input.createTextRange) {
    const range = input.createTextRange();
    range.collapse(true);
    range.moveStart('character', start);
    range.moveEnd('character', end - start);
    range.select();
  }
};